<template>
  <div class="index-originality-component">
    <div class="app-flex-row-center">
      <ul class="switch font-14 app-flex-row-space-between">
        <li
          v-for="(item, index) in switchData"
          :key="item.id"
          class="switch-item font-color-white"
          :class="{ active: activeIndex == index }"
          @click="() => switchChange(index)"
        >
          <div class="switch-text text-center">{{ item.name }}</div>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div v-if="activeIndex == 0" class="app-flex-row-space-between">
        <OriVideo
          v-for="item in originalityList.video"
          :key="item.id"
          :data="item"
        ></OriVideo>
      </div>
      <div v-if="activeIndex == 1" class="app-flex-row-space-between">
        <OriBlog
          v-for="item in originalityList.blog"
          :key="item.id"
          :data="item"
        ></OriBlog>
      </div>
      <div v-if="activeIndex == 2" class="app-flex-row-space-between">
        <OriImage
          v-for="item in imageList"
          :key="item.src"
          :data="item"
        ></OriImage>
      </div>
    </div>
  </div>
</template>

<script>
import OriVideo from '@/components/originality/OriVideo'
import OriBlog from '@/components/originality/OriBlog'
import OriImage from '@/components/originality/OriImage'
import oriImg1 from '@/assets/img/index-originality/ori_img_1.jpeg'
import oriImg2 from '@/assets/img/index-originality/ori_img_2.png'
import oriImg3 from '@/assets/img/index-originality/ori_img_3.png'
import oriImg4 from '@/assets/img/index-originality/ori_img_4.png'

export default {
  components: {
    OriVideo,
    OriBlog,
    OriImage
  },
  inheritAttrs: false,
  props: {
    originalityList: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      activeIndex: 0,
      imageList: [
        {
          src: oriImg1
        },
        {
          src: oriImg2
        },
        {
          src: oriImg3
        },
        {
          src: oriImg4
        }
      ],
      switchData: [
        { id: 3, name: '视频类' },
        { id: 1, name: '博文类' },
        { id: 2, name: '图片类' }
      ]
    }
  },
  methods: {
    switchChange(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.index-originality-component {
  .switch {
    width: 756px;
    border-bottom: 3px solid rgba(255, 255, 255, 0.1);
    .switch-item {
      opacity: 0.85;
      width: 216px;
      cursor: pointer;
      .switch-text {
        width: 100%;
        position: relative;
        padding-bottom: 12px;
      }
      &:hover {
        opacity: 1;
      }
      &.active {
        .switch-text:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -3px;
          width: 100%;
          height: 3px;
          background-color: $white;
        }
      }
    }
  }
  .tab-content {
    color: $white;
    padding: 40px 0 48px;
  }
}
</style>
